/**
 * Per-block CSS targeting hook for imported designs.
 *
 * Every imported block renders this deterministic class (`cb-<block-uuid>`)
 * alongside its source design classes. The design-editor chat's `update_css`
 * tool uses it to scope a rule to ONE block instance — the shared source
 * classes (`.brief-card`, `.section`) can't, since they hit every sibling.
 *
 * Derived, never stored: keeping it out of `theme.tailwindClasses` (the field
 * the scoped CSS binds to) avoids both the merge/clobber hazard and a
 * migration. At equal specificity (`.imported-design-X .cb-Y` is 0,2,0, same
 * as the source `.imported-design-X .brief-card`) an override wins purely on
 * source order — `user_css_overrides` is appended after the source CSS in
 * HandleInertiaRequests, so the later rule takes precedence.
 *
 * A UUID-derived class (`cb-9f8a...`) is a valid CSS identifier: it starts with
 * a letter and contains only alphanumerics and hyphens, so no escaping is
 * needed in the selector the chat writes.
 */
export function importHookClass(contentBlockId: string): string {
    return `cb-${contentBlockId}`;
}
